import styled from '@emotion/styled';
import {useEffect, useMemo, useState} from 'react';
import { useTranslation } from 'react-i18next';
import { useOutletContext } from 'react-router-dom';
import { responseTypes } from '@selfserve/react-utils';
import { IContextData } from './admin-layout';
import {useAnnouncementsRequest} from '../data';
import { getAdminSearchValue } from '../utils/get-admin-search-value';
import { StyledPageTitle } from '../ui/admin-styled-components';
import {useCustomSearchParams} from "@selfserve/react-hooks";
import {IBeFilter} from "../types";
import {AdminChecklistsList} from "./admin-checklists-list";
import {AdminSpinner} from "../ui/admin-spinner";
import {useSortByUrl} from "../hooks/use-sort-by-url";

const StyledAdminChecklistsContainer = styled('div')`
  height: 100%;
`;

export const AdminAnnouncements = () => {
  const { t } = useTranslation();
  const [query] = useCustomSearchParams();
  const { openErrorModal } = useOutletContext<IContextData>() || {};
  const { sortValue, sortType } = useSortByUrl();
  const [beFilter, setBeFilter] = useState<null | IBeFilter>(null);
  const { data,refetch, isLoading } = useAnnouncementsRequest({
    pageSize: +query['pageSize'],
    pageIndex: +query['pageIndex'] - 1,
    ...(beFilter && beFilter),
    ...(query['status'] && {
      status: (query['status'] as string[])?.join(','),
    }),
    ...(sortValue && {
      sortByItems: sortValue,
    }),
    ...(sortType && {
      sortByDirection: sortType,
    }),
    type: 'announcement',
  });

  const announcements = useMemo(() => {
    if (data?.data && Array.isArray(data?.data)) return data?.data;
    return [];
  }, [data]);

  useEffect(() => {
    if (data?.status && !String(data?.status).startsWith(responseTypes.SUCCESS)) {
      openErrorModal({ text: data?.data?.message });
    }
  }, [data]);

  return (
    <StyledAdminChecklistsContainer>
      <StyledPageTitle isSmall>{t('common.admin-announcements')}</StyledPageTitle>
      <AdminChecklistsList
        checklists={announcements}
        refetch={refetch}
        handleSetBeFilter={getAdminSearchValue(setBeFilter)} />
      <AdminSpinner loading={isLoading} fullScreen />
    </StyledAdminChecklistsContainer>
  );
};
